// utils/auth.js

export const AUTH_MESSAGE_KEY = 'appAuthMessage';
export const SESSION_EXPIRED_EVENT = 'app-session-expired';

let handlingSessionExpired = false;
let sessionExpiredDialogOpen = false;
let sessionExpiredUI = null;

const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/`;
};

export const storeToken = async (data) => {
    localStorage.setItem('authToken', data.token);
    localStorage.setItem('userId', data.clientId);
    
    if (data.initSetupDone !== undefined) {
      localStorage.setItem('initSetupDone', data.initSetupDone);
    }

    setCookie('appilix_push_notification_user_identity', data.clientId, 30);
  };
  
  export const getToken = async () => {
    const token = localStorage.getItem('authToken');
    return token ? token : null;
  };
  
  export const removeToken = async () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('initSetupDone');
    localStorage.removeItem('parentId');
  };

let cachedAuthMessage;
let authMessageRead = false;

export function consumeAuthMessage() {
  if (!authMessageRead) {
    authMessageRead = true;
    try {
      cachedAuthMessage = sessionStorage.getItem(AUTH_MESSAGE_KEY) || localStorage.getItem(AUTH_MESSAGE_KEY) || '';
      if (cachedAuthMessage) {
        sessionStorage.removeItem(AUTH_MESSAGE_KEY);
        localStorage.removeItem(AUTH_MESSAGE_KEY);
      }
    } catch (e) {
      cachedAuthMessage = '';
    }
  }
  return cachedAuthMessage || '';
}

export function friendlySessionExpiredMessage(message) {
  const text = message ? String(message).trim() : '';
  if (text && /please login again/i.test(text)) {
    return text;
  }
  return 'Session expired. Please login again.';
}

export function setSessionExpiredUI(handler) {
  sessionExpiredUI = typeof handler === 'function' ? handler : null;
}

function persistAuthMessage(displayMessage) {
  try {
    sessionStorage.setItem(AUTH_MESSAGE_KEY, displayMessage);
  } catch (e) {}
  try {
    localStorage.setItem(AUTH_MESSAGE_KEY, displayMessage);
  } catch (e) {}
}

function clearAuthStorage() {
  localStorage.removeItem('authToken');
  localStorage.removeItem('userId');
  localStorage.removeItem('initSetupDone');
  localStorage.removeItem('parentId');
}

function hardRedirectToLogin() {
  const origin = window.location.origin || '';
  const next = origin + '/login?session=expired&t=' + Date.now();
  try {
    window.location.href = next;
  } catch (e) {
    try {
      window.location.assign(next);
    } catch (err) {
      window.location.reload();
    }
  }
}

export function notifySessionExpired(message) {
  if (sessionExpiredDialogOpen || handlingSessionExpired) {
    return;
  }
  sessionExpiredDialogOpen = true;

  const displayMessage = friendlySessionExpiredMessage(message);

  if (typeof sessionExpiredUI === 'function') {
    sessionExpiredUI(displayMessage);
    return;
  }

  try {
    window.dispatchEvent(
      new CustomEvent(SESSION_EXPIRED_EVENT, { detail: { message: displayMessage } })
    );
  } catch (e) {}

  window.setTimeout(function () {
    if (handlingSessionExpired) {
      return;
    }
    try {
      window.alert(displayMessage);
    } catch (e) {}
    logoutDueToExpiredSession(displayMessage);
  }, 250);
}

export function logoutDueToExpiredSession(message) {
  if (handlingSessionExpired) {
    return;
  }
  handlingSessionExpired = true;
  sessionExpiredDialogOpen = true;

  const displayMessage = friendlySessionExpiredMessage(message);
  persistAuthMessage(displayMessage);
  clearAuthStorage();
  hardRedirectToLogin();
}
